/**
 * Created by sung on 2017-02-07.
 */
import {Component, NgModule, OnInit, ViewChild} from '@angular/core';
import {PanelModule,DataTableModule,DropdownModule,ChartModule} from 'primeng/primeng';
import { MamAdminService } from '../../service/mam_service.component';
import {SelectItem} from "primeng/components/common/api";
import {CommonModule, DatePipe} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {FormsModule} from "@angular/forms";
//import {type} from "os";
import {UIChart} from "primeng/components/chart/chart";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS'
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {TranslateServiceForm, TranslatePipeMoudle} from '../../translate';
import {MainPipeMoudle} from "../../pipe/main.pipe";

@Component({

  templateUrl: './front_main.html'
})

export class FrontMainComponent implements OnInit{

  @ViewChild("chart") chart : UIChart;
  //@ViewChild("auditChart") auditChart : UIChart;
  @ViewChild("inOutChart") inOutChart : UIChart;
  @ViewChild("rootChart") rootChart : UIChart;
  mdm_statistics : any;
  periods : SelectItem[] = [];
  period : string = 'week';
  logLineData : any;

  labelss : string[]=[];
  tFatalData : number[] =[];
  tWarnData : number[] =[];


  tableList : any;
  auditHour : number[] =[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
  auditData : any;

  inOutData : any;

  rootData : any;

  selectedCompany : any;

  datePipe : any;
  date = new Date();
  sDate : string;

  rootDeviceList :any;
  removeProfileLogList :any;
  chartOptions : any;
  constructor(private  service:  MamAdminService, private logger : Logger, private _translate : TranslateServiceForm) {
    this.periods.push({label : this._translate.instant('LANG_Weekly'), value : 'week'});
    /*this.periods.push({label : this._translate.instant('LANG_Hourly'), value : 'hour'});*/
    this.periods.push({label : this._translate.instant('LANG_Daily'), value : 'day'});
    this.periods.push({label : this._translate.instant('LANG_Monthly'), value : 'month'});

    this.logLineData = {
      labels: [],
      datasets: [
        {
          label: this._translate.instant('Severity_WARN'),
          data: [0,0,0],
          fill: true,
          borderColor: '#4bc0c0'
        },
        {
          label: this._translate.instant('Severity_FATAL'),
          data: [0, 0, 0],
          fill: true,
          borderColor: '#ff0000'
        }
      ]
    };


    /*this.auditData = {
      labels: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      datasets: [
        {
          label: '시간별 개수',
          backgroundColor: '#9CCC65',
          borderColor: '#1E88E5',
          fill: false,
          data: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
        }
      ]
    };*/

    this.inOutData = {
      labels: ['IN','OUT'],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: [
            "#ac83ca",
            "#65a23a"
          ],
          hoverBackgroundColor: [
            "#ac777a",
            "#abc32a"
          ]
        }]
    };

    this.rootData = {
      labels: [this._translate.instant('LANG_Rooting'),this._translate.instant('LANG_Normal')],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: [
            "crimson",
            "darkgoldenrod"
          ],
          hoverBackgroundColor: [
            "crimson",
            "darkgoldenrod"
          ]
        }]
    };
    this.chartOptions = {
//      responsive: false,
      maintainAspectRatio: false,
      responsive : false
    };
  }

  ngOnInit() {
    this.datePipe = new DatePipe("en");
    this.sDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    setTimeout(() => {
      this.getAuditLogListByCompany(0,9999,"","", this.selectedCompany.id, this.sDate, this.sDate);
      this.getPolicyApplyDataByCompany(this.selectedCompany.id);
      this.getRootingDeviceCountCompany(this.selectedCompany.id);
      this.getRootingDeviceCompany(this.selectedCompany.id);
      this.getRemoveProfileLog(this.selectedCompany.id);
    }, 3600000);
  }

  changeDrop(event){
    this.getIssueStatistics(this.selectedCompany.id, event.value);
  }


  setMdmlogData() {
    this.labelss = [];
    this.tFatalData =[];
    this.tWarnData = [];
    let fatalDatas = this.mdm_statistics.fatalData;
    let warnDatas = this.mdm_statistics.warnData;

    for(let i = 1 ; i <= 5 ; i++) {
      if(this.period == 'week') this.labelss.push(i + 'w');
      else if(this.period == 'month') this.labelss.push(i + 'm');
      else if(this.period == 'day') this.labelss.push(i + 'd');
      else if(this.period == 'hour') this.labelss.push(i + 'h');
      else this.labelss.push(i + '');
      this.tFatalData.push(fatalDatas[i]);
      this.tWarnData.push(warnDatas[i]);
    }

    this.logLineData.labels = this.labelss;
    this.logLineData.datasets[0].data=this.tWarnData;
    this.logLineData.datasets[1].data=this.tFatalData;
    this.chart.refresh();
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.auditHour.fill(0);
    setTimeout(() => {
      this.getAuditLogListByCompany(0, 999, '', '', company.id, this.sDate, this.sDate);
      this.getIssueStatistics(company.id, "week");
      this.getPolicyApplyDataByCompany(company.id);
      this.getRootingDeviceCountCompany(company.id);
      this.getRootingDeviceCompany(company.id);
      this.getRemoveProfileLog(company.id);
    }, 200);
  }

  //------------------------- Service ---------------------
  getIssueStatistics(companyId:number, type:string) {
    this.service.getIssueStatistics(companyId, type).subscribe(
        value => {
          this.logger.debug("issue statis :" , value);
          this.mdm_statistics = value;
          if(value) this.setMdmlogData();
          else this.logger.debug("no data");
        },
        error => {this.logger.error("-- error : " + error);},
        () => {}
    )
  }

  getAuditLogList(page:number, max:number, search:string, field:string, start:string, end:string){
    this.service.getAuditLogList(page, max, search, field, start, end).subscribe(
      value => {
        this.logger.debug("audit list :", value);
        this.tableList = value.content;
        //this.setAuditData();
      },
      error=>{this.logger.error("-- error : " + error);},
      ()=>{}
    )
  }

  getAuditLogListByCompany(page:number, max:number, search:string, field:string, companyId:number, start:string, end:string){
    this.service.getAuditLogListByCompany(page, max, search, field, companyId, start, end).subscribe(
      value => {
        this.logger.debug("audit company list :", value);
        this.tableList = value.content;
        //this.setAuditData();
      },
      error=>{this.logger.error("-- error : " + error);},
      ()=>{}
    )
  }

  /*setAuditData() {
    if(this.tableList && this.tableList.length > 0){
      this.tableList.forEach(item => {
        let time_H  = this.datePipe.transform(item.createDate,"HH");
        this.auditHour[time_H] = this.auditHour[time_H] +1;
      });
      this.auditData.datasets[0].data = this.auditHour;
      this.auditChart.refresh();
    } else {
      this.auditChart.refresh();
    }
  }*/

  getPolicyApplyDataByCompany(companyId:number) {
    this.service.getPolicyApplyDataByCompany(companyId).subscribe(
      value => {
        let data : any;
        data = value;
        this.logger.debug("-- PolicyApplyData : " , value);
        this.inOutData.datasets[0].data = [data.count,data.notApplyCount];
        this.inOutChart.refresh();
      },
      error=>{this.logger.error("-- error : " + error);},
      ()=>{}
    )
  }

  getRootingDeviceCountCompany(companyId:number){
    this.service.getRootingDeviceCountCompany(companyId).subscribe(
        value => {
          let data : any;
          data = value;
          this.logger.debug("-- rootDeviceCount : " , value);
          this.rootData.datasets[0].data = [data.rootCount,data.notRootCount];
          this.rootChart.refresh();
        },
        error=>{this.logger.error("-- error : " + error);}
    )
  }

  getRootingDeviceCompany(companyId:number){
    this.service.getRootingDeviceCompany(companyId).subscribe(
        value => {
          this.logger.debug("-- rootDevice : " , value);
          this.rootDeviceList = value;
        },
        error=>{this.logger.error("-- error : " + error);}
    )
  }

  getRemoveProfileLog(companyId:number){
    this.service.getRemoveProfileLog(companyId).subscribe(
        value => {
          this.logger.debug("-- getRemoveProfileLog : " , value);
          this.removeProfileLogList = value;
        },
        error=>{this.logger.error("-- error : " + error);}
    )
  }


}

@NgModule({
  imports: [DataTableModule,DropdownModule,CommonModule,DropdownModule,BrowserModule,HttpModule,FormsModule,ChartModule, CompanyDropDownListModule, TranslatePipeMoudle, MainPipeMoudle],
  declarations: [FrontMainComponent],
  exports: [FrontMainComponent],
  providers: [MamAdminService]
})

export class FrontMainModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/main/front_main.ts